import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { transientOptions } from '../../constants/transientOptions'
import { Color } from '../../enums/color'
import { FontWeight } from '../../enums/fontWeight'
import { Spacing } from '../../enums/spacing'
import { getDefaultTransition } from '../../utils/getDefaultTransition'
import { Badge } from '../Badge'

interface TabProps {
  active?: boolean
}

export const Tab = styled('div', transientOptions)<TabProps>`
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  justify-content: center;
  padding: ${Spacing.S12} ${Spacing.S16};
  color: ${({ active }) => (active ? Color.Grey950 : Color.Grey800)};
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  ${getDefaultTransition('box-shadow')};

  &:hover {
    box-shadow: inset 0 -1px 0 ${Color.Lavender500};
  }

  ${({ active }) =>
    active &&
    css`
      &,
      &:hover {
        box-shadow: inset 0 -2px 0 ${Color.Lavender500};
        font-weight: ${FontWeight.Bold};
      }
    `};
`

export const IconWrapper = styled.span`
  display: flex;
  margin-right: ${Spacing.S8};
`

export const BadgeCounter = styled(Badge)`
  margin-left: ${Spacing.S8};
`
